import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=c11de362&"
import script from "./Form2_Persona.vue?vue&type=script&lang=js&"
export * from "./Form2_Persona.vue?vue&type=script&lang=js&"
import style0 from "./Form2_Persona.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c11de362')) {
      api.createRecord('c11de362', component.options)
    } else {
      api.reload('c11de362', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=c11de362&", function () {
      api.rerender('c11de362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/ES/Form2_Persona.vue"
export default component.exports